import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import { PartType } from '@/views/materialsList/types/part'
import { computed, onMounted, ref } from 'vue'

interface toggleConfilctPartType {
  index: number
  part: PartType
  type: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'g-conflict-part-modal',
  props: {
    label: { default: '板件名' },
    nextBtnText: { default: translateLang('下一个') },
    lastBtnText: { default: translateLang('上一个') },
    cancelBtnText: { default: translateLang('返回') },
    conflictParts: null,
    visiable: { type: Boolean, default: false },
    type: { default: 'conflitPart' },
    zIndex: { default: 9 },
    showCancelBtn: { type: Boolean, default: true }
  },
  emits: ["toggleConflictPart", "update:visiable"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggleConflictPart', payload: toggleConfilctPartType): void
  (e: 'update:visiable', v: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { label: string, nextBtnText: string, lastBtnText: string, cancelBtnText: string, conflictParts: PartType[], visiable: boolean, type: string, zIndex: number, showCancelBtn: boolean }




// 板件属性和描述的映射
const textMapToProp: Record<string, keyof PartType> = {
  板件名: 'partName',
}

const index = ref(1)
// 超尺板件数据根据当前的index进行动态获取
const currentPart = computed(() => {
  return props.conflictParts[index.value - 1]
})

const showConflictPartDetail = computed({
  get() {
    return props.visiable
  },
  set(v) {
    emit('update:visiable', v)
  },
})

const handleToggleConflictPart = (type: 'last' | 'next') => {
  if (type === 'last') {
    index.value--
    if (index.value === 0) {
      index.value = props.conflictParts.length
    }
  } else {
    index.value++
    if (index.value === props.conflictParts.length + 1) {
      index.value = 1
    }
  }
  emit('toggleConflictPart', {
    index: index.value,
    part: currentPart.value,
    type: 'conflictPart',
  })
}
const handleGoBack = () => {
  showConflictPartDetail.value = false
}

onMounted(() => {
  emit('toggleConflictPart', {
    index: index.value,
    part: currentPart.value,
    type: 'conflictPart',
  })
})

return { __sfc: true,props, emit, textMapToProp, index, currentPart, showConflictPartDetail, handleToggleConflictPart, handleGoBack }
}

})